export const getPaymentMethodByID = (id, paymentMethodList) => {
  return paymentMethodList.find(pm => pm.id == id)
}
